<template>
  <v-dialog v-model="dialog" persistent max-width="1000px">
    <v-card-title>
      <v-row>
        <v-col
          cols="10"
          lg="11"
          md="11"
          sm="11"
          style="text-align: center; padding-left: 9%;"
        >
          <span class="text-333 font-20 w-700"
            >แบบฟอร์มขอรับยา (ลงทะเบียนแทน)</span
          >
        </v-col>
        <v-col cols="2" lg="1" md="1" sm="1" class="pl-8">
          <v-btn @click="closeDialog()" icon>
            <v-icon class="font-18">mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider color="#e8e9e9"></v-divider>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <div
              style="overflow-y: auto; overflow-x: hidden; height: 515px; padding-left;: 10%; padding-right;: 10%"
            >
              <v-form
                ref="create_info"
                class="px-3"
                style="line-height: 1.8rem;"
              >
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pl-3">
                    <v-autocomplete
                      attach
                      class="set-font-label"
                      label="ค้นหาโดยชื่อของคนไข้"
                      v-model="keyword"
                      :search-input.sync="searchUserAPI"
                      :filter="userFilter"
                      solo
                      dense
                      hide-details="auto"
                      clear-icon="mdi-close-circle"
                      clearable
                      @click:clear="resetDialog"
                      :items="users"
                      item-value="value"
                      item-text="text"
                      return-object
                      @keypress.enter="getDataUser(searchUserAPI)"
                      color="#00A99D"
                      item-color="teal darken-2"
                      hint="กรอกคำค้นหา แล้วกด Enter เพื่อค้นหา"
                    >
                      <template slot="append">
                        <v-btn text icon>
                          <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:append-outer>
                        <v-slide-x-reverse-transition mode="out-in">
                          <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs" v-on="on"
                                style="border-radius: 20px 5px;height: 38px; color: white"
                                color="#00A99D"
                                @click="getDataUser(searchUserAPI)"
                              >
                                <v-icon medium dark>mdi-magnify</v-icon>
                              </v-btn>
                            </template>
                            <span>ค้นหา</span>
                          </v-tooltip>
                        </v-slide-x-reverse-transition>
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <div class="d-flex flex-column my-2">
                          <span>ชื่อ : {{ item.text }}</span>
                          <span>เบอร์ : {{ item.mobile }}</span>
                        </div>
                      </template>
                      <template slot="no-data">
                        <span class="pl-2"
                          >ค้นหาโดยชื่อหรือเบอร์โทรคนไข้ไม่พบ</span
                        >
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <!-- ข้อมูลส่วนตัว -->
                <v-row class="pt-0" justify="center">
                  <v-col cols="auto">
                    <span class="w-700 font-18 text-00A99D">ข้อมูลส่วนตัว</span>
                  </v-col>
                  <v-divider
                    style="align-self:center"
                    class="mr-3"
                    color="#00A99D"
                  ></v-divider>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
                    <span class="font-18 w-500 text-333333">คำนำหน้าชื่อ</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-select
                      solo
                      :rules="rules.rule_title"
                      v-model="data.account_title_th"
                      :items="['เด็กชาย', 'เด็กหญิง', 'นาย', 'นาง', 'นางสาว']"
                      dense
                      color="#00A99D"
                      item-color="teal darken-2"
                      :menu-props="{ bottom: true, offsetY: true }"
                      hide-details="auto"
                      :disabled="keyword !== null"
                    >
                    <template slot="append">
                      <v-btn text icon>
                        <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                  </v-select>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
                    <span class="font-18 w-500 text-333333">ชื่อ</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกชื่อ"
                      v-model="data.first_name_th"
                      :rules="rules.rule_name"
                      required
                      :disabled="keyword !== null"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
                    <span class="font-18 w-500 text-333333">นามสกุล</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกนามสกุล"
                      v-model="data.last_name_th"
                      :rules="rules.rule_lastname"
                      required
                      :disabled="keyword !== null"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pb-0">
                    <span class="font-18 w-500 text-333333">ประเภทบัตร</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-select
                      :items="card_type"
                      dense
                      solo
                      v-model="data.id_card_type"
                      color="#00A99D"
                      item-color="teal darken-2"
                      :menu-props="{ bottom: true, offsetY: true }"
                      hide-details="auto"
                      @change="clear()"
                      :disabled="keyword !== null"
                    >
                    <template slot="append">
                      <v-btn text icon>
                        <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                  </v-select>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pb-0">
                    <span
                      v-if="data.id_card_type == 'บัตรประจำตัวประชาชน'"
                      class="font-18 w-500 text-333333"
                      >บัตรประจำตัวประชาชน</span
                    >
                    <span
                      v-else-if="data.id_card_type == 'Passport'"
                      class="font-18 w-500 text-333333"
                      >Passport</span
                    >
                    <span class="text-red font-18 w-500"> *</span>
                    <v-text-field
                      v-if="data.id_card_type === 'บัตรประจำตัวประชาชน'"
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกเลขบัตรประจำตัวประชาชน"
                      :rules="rules.rule_cardnum"
                      v-model="data.cardnum"
                      :disabled="keyword !== null"
                      v-mask="mask_id"
                      @input="splitDat()"
                    ></v-text-field>
                    <v-text-field
                      v-else-if="data.id_card_type === 'Passport'"
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกเลขที่หนังสือเดินทาง"
                      :rules="rules.rule_passport"
                      v-model="data.cardnum"
                      :disabled="keyword !== null"
                      v-mask="mask_pass"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pb-0">
                    <span class="font-18 w-500 text-333333"
                      >เลขบัตรประจำตัวโรงพยาบาล (HN)</span
                    >
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      v-model="data.cardHN"
                      placeholder="กรอกเลขบัตรประจำตัวโรงพยาบาล"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pb-0">
                    <span class="font-18 w-500 text-333333">วันเกิด</span>
                    <v-menu
                      v-model="day_menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="350px"
                      min-width="auto"
                      bottom
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          solo
                          dense
                          append-icon="mdi-calendar-multiselect"
                          placeholder="วัน/เดือน/ปี"
                          :value="displayDate()"
                          readonly
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          color="#00A99D"
                          item-color="teal darken-2"
                        >
                          <template slot="append">
                            <v-btn text icon v-on="on">
                              <v-icon color="#00A99D"
                                >mdi-calendar-multiselect</v-icon
                              >
                            </v-btn>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="data.birth_date"
                        :max="dateNow"
                        no-title
                        scrollable
                        locale="th"
                        @input="day_menu = false"
                        color="#00A99D"
                        :active-picker="activePicker"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="#00A99D" @click="clearDaySelect"
                          >ล้างค่า/clear</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pb-0">
                    <span class="font-18 w-500 text-333333">เบอร์โทรศัพท์</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกเบอร์โทรศัพท์"
                      v-model="data.mobile"
                      :rules="rules.rule_mobile"
                      required
                      v-mask="[mask_mobile1, mask_mobile2]"
                      @input="splitDat2('mobile')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pb-0">
                    <span class="font-18 w-500 text-333333">อีเมลล์</span>
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกอีเมลล์"
                      v-model="data.email"
                      :rules="data.email == '' ? rules.rule_email_unrequired : rules.rule_email"
                       required
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pb-0">
                    <span class="font-18 w-500 text-333333">เบอร์โทรศัพท์ อื่น ๆ</span>
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกเบอร์โทรศัพท์ อื่น ๆ"
                      v-model="data.mobile_other"
                      v-mask="[mask_mobile1, mask_mobile2]"
                      @input="splitDat2('other')"
                    ></v-text-field>
                  </v-col>
                </v-row> -->

                <!-- ข้อมูลสถานที่รับยา -->
                <v-row class="pt-3" justify="center">
                  <v-col cols="auto">
                    <span class="w-700 font-18 text-00A99D"
                      >ข้อมูลสถานที่รับยา</span
                    >
                  </v-col>
                  <v-divider
                    style="align-self:center"
                    class="mr-3"
                    color="#00A99D"
                  ></v-divider>
                </v-row>
                <v-row class="pt-0">
                  <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
                    <span class="font-18 w-500 text-333333">บ้านเลขที่</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกบ้านเลขที่"
                      v-model="data.houseNo"
                      :rules="rules.rule_house_no"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
                    <span class="font-18 w-500 text-333333">หมู่ที่</span>
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกหมู่"
                      v-model="data.moo"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
                    <span class="font-18 w-500 text-333333">ถนน/ซอย</span>
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกถนน/ซอย"
                      v-model="data.road"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="4" md="4" sm="4" class="pb-0">
                    <span class="font-18 w-500 text-333333">จังหวัด</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-autocomplete
                      :items="province"
                      item-value="province"
                      item-text="province"
                      @input="getAmphoe('template')"
                      :menu-props="{ bottom: true, offsetY: true }"
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรุณาเลือกจังหวัด"
                      v-model="data.province"
                      :rules="rule_province"
                      item-color="teal darken-2"
                      color="#00A99D"
                      required
                    >
                      <template slot="append">
                        <v-btn text icon>
                          <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <template slot="no-data">
                        <span class="pl-2">ไม่มีข้อมูลจังหวัด</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" sm="4" class="pb-0">
                    <span class="font-18 w-500 text-333333">อำเภอ/เขต</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-autocomplete
                      :items="amphoe"
                      item-value="amphoe"
                      item-text="amphoe"
                      @input="getTambon"
                      :menu-props="{ bottom: true, offsetY: true }"
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรุณาเลือกอำเภอ/เขต"
                      v-model="data.amphur"
                      :rules="rule_amphur"
                      item-color="teal darken-2"
                      color="#00A99D"
                      required
                    >
                      <template slot="append">
                        <v-btn text icon>
                          <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <template slot="no-data">
                        <span class="pl-2">กรุณาเลือกจังหวัด</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" sm="4" class="pb-0">
                    <span class="font-18 w-500 text-333333">ตำบล/แขวง</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-autocomplete
                      :items="tambon"
                      item-value="tambon"
                      item-text="tambon"
                      @input="getPostal($event), showAddress()"
                      :menu-props="{ bottom: true, offsetY: true }"
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรุณาเลือกตำบล/แขวง"
                      v-model="data.tambon"
                      :rules="rule_tambon"
                      item-color="teal darken-2"
                      color="#00A99D"
                      required
                    >
                      <template slot="append">
                        <v-btn text icon>
                          <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <template slot="no-data">
                        <span class="pl-2">กรุณาเลือกอำเภอ</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="4" md="4" sm="4" class="pb-0">
                    <span class="font-18 w-500 text-333333">รหัสไปรษณีย์</span>
                    <span class="text-red font-18 w-500"> *</span>
                    <v-text-field
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกรหัสไปรษณีย์"
                      v-model="data.postal_code"
                      :rules="rule_postal_code"
                      @input="showAddress()"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pb-0">
                    <span class="font-18 w-500 text-333333"
                      >จุดสังเกตเพิ่มเติม</span
                    >
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="pb-0">
                    <span class="font-18 w-500 text-333333"
                      >หมายเหตุ</span
                    >
                  </v-col>
                </v-row>
                <v-row class="pb-3">
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-0">
                    <v-textarea
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกจุดสังเกตเพิ่มเติม"
                      v-model="data.landmark"
                      rows="3"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6" class="py-0">
                    <v-textarea
                      solo
                      dense
                      hide-details="auto"
                      placeholder="กรอกหมายเหตุ"
                      v-model="data.note"
                      rows="3"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row class="pb-3">
                  <v-col
                    cols="12"
                    lg="4"
                    md="4"
                    sm="4"
                    class="py-0"
                    align-self="end"
                  >
                    <v-btn
                      depressed
                      color="#F7F8FA"
                      @click="checkGPS()"
                      block
                      style="white-space: normal;display: inline;"
                    >
                      <v-icon size="20" class="pr-1" color="#00A99D"
                        >mdi-crosshairs-gps</v-icon
                      ><span class="text-7E8386 w-400 font-14"
                        >คลิกเพื่อหาที่อยู่ปัจจุบันของคุณ</span
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
                    <span class="font-18 w-500 text-333333">ละติจูด</span>
                    <v-text-field
                      v-model="data.lat"
                      placeholder="ละติจูด"
                      solo
                      dense
                      @input="getGPS()"
                      hide-details="auto"
                      :rules="rules.rule_lat"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
                    <span class="font-18 w-500 text-333333">ลองติจูด</span>
                    <v-text-field
                      v-model="data.lng"
                      placeholder="ลองติจูด"
                      solo
                      dense
                      @input="getGPS()"
                      hide-details="auto"
                      :rules="rules.rule_lng"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="pb-3">
                  <v-col cols="12" class="py-0">
                    <!-- <GmapAutocomplete
                      @place_changed="setPlace"
                      class="pl-2 gmap-auto"
                      :value="search"
                      :options="{
                        fields: [
                          'geometry',
                          'formatted_address',
                          'address_components',
                        ],
                      }"
                    /> -->
                    <v-text-field
                      solo
                      dense
                      placeholder="ค้นหาตำแหน่งที่อยู่"
                      v-model="location_address"
                      hide-details="auto"
                      @keypress.enter="getLocation(location_address)"
                      color="#00A99D"
                      hint="กรอกคำค้นหา กด Enter หรือ กดปุ่มค้นหา เพื่อค้นหาที่อยู่ของท่าน"
                    >
                      <template slot="append">
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs" v-on="on"
                              icon
                              color="#00A99D"
                              @click="getLocation(location_address)"
                            >
                              <v-icon medium dark>mdi-magnify</v-icon>
                            </v-btn>
                          </template>
                          <span>ค้นหา</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="pb-3">
                  <v-col cols="12" class="py-0">
                    <GmapMap
                      :center="{ lat: latitude, lng: longitude }"
                      :zoom="15"
                      class="map"
                      :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: true,
                        fullscreenControl: true,
                        disableDefaultUi: true,
                      }"
                    >
                      <GmapMarker
                        @click="changeLocation"
                        @dragend="changeLocation"
                        :draggable="true"
                        :position="{
                          lat: lat,
                          lng: lng,
                        }"
                      />
                    </GmapMap>
                  </v-col>
                </v-row>
              </v-form>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-divider color="#e8e9e9"></v-divider>
    <v-card-actions>
      <v-row justify="center" align="center" class="ma-0">
        <v-col cols="12" lg="3" md="3" sm="3">
          <v-btn block depressed color="#00A99D" style="border-radius: 20px 5px;" @click="checkAlert()">
            <span class="text-white">ส่งแบบฟอร์ม</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <Sweetdialog ref="sweetDialog" @submit="saveForm" />
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { gmapApi } from "vue2-google-maps";
import Sweetdialog from "../Sweetdialog.vue";
export default {
  components: {
    Sweetdialog,
  },
  data() {
    return {
      mask_id: 'X-XXXX-X####-##-#',
      mask_pass: 'XXXXXXXXXXXXXXX',
      mask_mobile1: '###-###-####',
      mask_mobile2: '#-####-####',
      dialog: false,
      data: {
        biz_id: "",
        hospital_name: "",
        account_title_th: "เด็กชาย",
        first_name_th: "",
        last_name_th: "",
        birth_date: null,
        id_card_type: "บัตรประจำตัวประชาชน",
        cardnum: "",
        email: "",
        mobile: "",
        // mobile_other: "",
        cardHN: "",
        houseNo: "",
        moo: "",
        road: "",
        province: "",
        amphur: "",
        tambon: "",
        postal_code: "",
        address: "",
        lat: 0,
        lng: 0,
        landmark: "",
        note: '',
        consen: true,
        manual_type: "new reserve",
      },
      searchUserAPI: "",
      users: [],
      keyword: null,
      listUser: [],
      latitude: 0,
      longitude: 0,
      lat: 0,
      lng: 0,
      snackbar: false,
      rules: {
        rule_title: [(v) => !!v || "กรุณาเลือกคำนำหน้าชื่อ"],
        rule_name: [(v) => !!v || "กรุณากรอกชื่อ"],
        rule_note: [(v) => !!v || "กรุณากรอกข้อมูล"],
        rule_lastname: [(v) => !!v || "กรุณากรอกนามสกุล"],
        rule_clinic: [(v) => !!v || "กรุณาเลือกคลินิก"],
        rule_date: [(v) => !!v || "กรุณาเลือกวันที่"],
        rule_house_no: [(v) => !!v || "กรุณากรอกบ้านเลขที่"],
        rule_moo: [(v) => !!v || "กรุณากรอกหมู่"],
        rule_road: [(v) => !!v || "กรุณากรอกถนน"],
        rule_address: [(v) => !!v || "กรุณากรอกหมายเหตุ"],
        rule_time: [(v) => !!v || "กรุณาเลือกช่วงเวลาในการส่งยา"],
        rule_cardHN: [(v) => !!v || "กรุณากรอกเลขบัตรประจำตัวโรงพยาบาล"],
        rule_radio: [(v) => !!v || "กรุณาเลือก"],
        rule_cardnum: [
          (v) => v.length != 0 || "กรุณากรอกเลขบัตรประจำตัวประชาชน",
          (v) => v.length === 17 || v.length === 0 || "กรุณากรอกให้ครบ 13 หลัก",
        ],
        rule_passport: [
          (v) => v.length != 0 || "กรุณากรอกเลขที่หนังสือเดินทาง",
        ],
        rule_mobile: [
          (v) => !!v || "กรุณากรอกเบอร์โทรศัพท์ผู้ป่วยหรือญาติ",
          (v) => v.length === 11 || v.length === 12 || "กรุณากรอกให้ครบ 9-10 หลัก",
        ],
        rule_department: [(v) => !!v || "กรุณาเลือกแผนก"],
        rule_lat: [
          (v) => !!v || "กรุณากรอกละติจูด",
          (v) => /^[0-9]+.[0-9]+$/.test(v) || "กรอกได้เฉพาะตัวเลข",
        ],
        rule_lng: [
          (v) => !!v || "กรุณากรอกลองติจูด",
          (v) => /^[0-9]+.[0-9]+$/.test(v) || "กรอกได้เฉพาะตัวเลข",
        ],
        rule_email: [
          (v) =>
            /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
              v
            ) || "กรอกอีเมล์ไม่ถูกต้อง",
          (v) => !!v || "กรุณากรอกอีเมล์",
        ],
        rule_email_unrequired: [
          (v) => v.length == 0 || "กรุณากรอกอีเมล์"
        ],
      },
      rule_tambon: [(v) => !!v || "กรุณาเลือกตำบล/แขวง"],
      rule_amphur: [(v) => !!v || "กรุณาเลือกอำเภอ/เขต"],
      rule_province: [(v) => !!v || "กรุณาเลือกจังหวัด"],
      rule_postal_code: [(v) => !!v || "กรุณากรอกรหัสไปรษณีย์"],
      card_type: ["บัตรประจำตัวประชาชน", "Passport"],
      province: [],
      amphoe: [],
      tambon: [],
      day_menu: false,
      regis_drug_form: "",
      radius_serve: [],
      save: {},
      dateNow: null,
      currentPlace: null,
      search: null,
      splitID: '',
      location_address: '',
      splitMobile: '',
      splitOtherMobile: '',
      activePicker: null,
    };
  },
  mounted() {
    this.checkGPS();
    this.getProvince();
  },
  computed: {
    ...mapGetters({
      // permiss: "permissionsGetter" || {},
      // path: "getPath" || "",
    }),
    google: gmapApi,
  },
  async created() {
    this.$store.dispatch("getSharedToken");
  },
  watch: {
    searchUserAPI() {
      if (this.searchUserAPI === "") {
        this.users = [];
      }
    },
    keyword() {
      this.setData();
    },
    day_menu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
  },
  methods: {
    clearMask() {
      this.mask_id = ''
      this.mask_pass = ''
      this.mask_mobile1 = ''
      this.mask_mobile2 = ''
    },
    splitDat() {
      if(this.data.cardnum.length == 17) {
        var x = this.data.cardnum.split('-')
        this.splitID = x[0]+x[1]+x[2]+x[3]+x[4]
      }
    },
    splitDat2(type) {
      if(type == 'mobile') {
        if(this.data.mobile.length >= 11 && this.data.mobile.length <= 12) {
          var x = this.data.mobile.split('-')
          this.splitMobile = x[0]+x[1]+x[2]
        }
      } else if(type == 'other') {
        if(this.data.mobile_other.length >= 11 && this.data.mobile_other.length <= 12) {
          var y = this.data.mobile_other.split('-')
          this.splitOtherMobile = y[0]+y[1]+y[2]
        }
      }
    },
    openDialog() {
      this.checkGPS();
      this.dialog = true;
      this.keyword = null;
      this.users = [];
      this.dateNow = moment().format("YYYY-MM-DD");
      this.location_address = ''
      this.mask_id = 'X-XXXX-X####-##-#'
      this.mask_pass = 'XXXXXXXXXXXXXXX'
      this.mask_mobile1 = '###-###-####'
      this.mask_mobile2 = '#-####-####'
      this.activePicker = null
    },
    closeDialog() {
      this.$refs.create_info.resetValidation();
      this.resetDialog();
      this.clearMask()
      this.activePicker = null
      this.dialog = false;
    },
    setData() {
      if (this.keyword) {
        // console.log('this.keyword', this.keyword);
        //account_title_th
        if (this.keyword.value.account_title_th) {
          this.data.account_title_th = this.keyword.value.account_title_th;
        } else {
          this.data.account_title_th = "";
        }

        //first_name_th
        if (this.keyword.value.first_name_th) {
          this.data.first_name_th = this.keyword.value.first_name_th;
        } else {
          this.data.first_name_th = "";
        }

        //last_name_th
        if (this.keyword.value.last_name_th) {
          this.data.last_name_th = this.keyword.value.last_name_th;
        } else {
          this.data.last_name_th = "";
        }

        //id_card_type
        if (this.keyword.value.data_user.id_card_type) {
          if(this.keyword.value.data_user.id_card_type == 'ID_CARD') {
            this.data.id_card_type = "บัตรประจำตัวประชาชน"
          } else {
            this.data.id_card_type = this.keyword.value.data_user.id_card_type;
          }
        } else {
          this.data.id_card_type = "";
        }

        //id_card_num
        if (this.keyword.value.id_card_num) {
          this.data.cardnum = this.keyword.value.id_card_num;
        } else {
          this.data.cardnum = "";
        }

        //HN
        if (this.keyword.value.data_user.HN) {
          this.data.cardHN = this.keyword.value.data_user.HN;
        } else {
          this.data.cardHN = "";
        }

        //birth_date
        if (this.keyword.value.birth_date) {
          this.data.birth_date = this.keyword.value.birth_date;
        } else {
          this.data.birth_date = "";
        }

        //mobile
        if (this.keyword.value.data_user.mobile) {
          this.data.mobile = this.keyword.value.data_user.mobile;
        } else {
          this.data.mobile = "";
        }

        //mobile_other
        // if (this.keyword.value.mobile_other) {
        //   this.data.mobile_other = this.keyword.value.mobile_other;
        // } else {
        //   this.data.mobile_other = "";
        // }

        //email
        if (this.keyword.value.data_user.email) {
          this.data.email = this.keyword.value.data_user.email;
        } else {
          this.data.email = "";
        }

        for(var i in this.keyword.value.data_user.address) {
          if(this.keyword.value.data_user.address[i].default == true) {
            //house_no
            if (this.keyword.value.data_user.address[i].houseNo) {
              this.data.houseNo = this.keyword.value.data_user.address[i].houseNo;
            } else {
              this.data.houseNo = "";
            }

            //moo
            if (this.keyword.value.data_user.address[i].moo) {
              this.data.moo = this.keyword.value.data_user.address[i].moo;
            } else {
              this.data.moo = "";
            }

            //road
            if (this.keyword.value.data_user.address[i].road) {
              this.data.road = this.keyword.value.data_user.address[i].road;
            } else {
              this.data.road = "";
            }

            //province
            if (this.keyword.value.data_user.address[i].province) {
              this.data.province = this.keyword.value.data_user.address[i].province;
            } else {
              this.data.province = "";
            }

            //amphur
            if (this.keyword.value.data_user.address[i].amphur) {
              this.data.amphur = this.keyword.value.data_user.address[i].amphur;
              this.getAmphoe("");
            } else {
              this.data.amphur = "";
            }

            //tambon
            if (this.keyword.value.data_user.address[i].tambon) {
              this.data.tambon = this.keyword.value.data_user.address[i].tambon;
              this.getTambon("");
            } else {
              this.data.tambon = "";
            }

            if (this.keyword.value.data_user.address[i].zipcode) {
              this.data.postal_code = this.keyword.value.data_user.address[i].zipcode;
            } else {
              this.data.postal_code = "";
            }

            //landmark
            if (this.keyword.value.data_user.address[i].landmark) {
              this.data.landmark = this.keyword.value.data_user.address[i].landmark;
            } else {
              this.data.landmark = "";
            }

            //lat lng
            if (
              this.keyword.value.data_user.address[i].lat &&
              this.keyword.value.data_user.address[i].lng
            ) {
              this.data.lat = this.keyword.value.data_user.address[i].lat;
              this.data.lng = this.keyword.value.data_user.address[i].lng;

              this.latitude = parseFloat(this.data.lat || 0);
              this.longitude = parseFloat(this.data.lng || 0);

              this.lat = parseFloat(this.data.lat || 0);
              this.lng = parseFloat(this.data.lng || 0);
              
            } else {
              this.data.lat = 0;
              this.data.lng = 0;
            }
          }
        }

        //note
        if (this.keyword.value.data_user.note) {
          this.data.note = this.keyword.value.data_user.note;
        } else {
          this.data.note = "";
        }
      }
    },
    resetDialog() {
      this.data = {
        biz_id: "",
        hospital_name: "",
        account_title_th: "เด็กชาย",
        first_name_th: "",
        last_name_th: "",
        birth_date: "",
        id_card_type: "บัตรประจำตัวประชาชน",
        cardnum: "",
        email: "",
        mobile: "",
        // mobile_other: "",
        cardHN: "",
        houseNo: "",
        moo: "",
        road: "",
        province: "",
        amphur: "",
        tambon: "",
        postal_code: "",
        address: "",
        lat: 0,
        lng: 0,
        landmark: "",
        note: '',
        consen: true,
        manual_type: "new reserve",
      };
      (this.keyword = null), (this.lat = parseFloat(this.lat || 0));
      this.lng = parseFloat(this.lng || 0);
      this.data.lat = parseFloat(this.data.lat || 0);
      this.data.lng = parseFloat(this.data.lng || 0);
      this.latitude = parseFloat(this.latitude || 0);
      this.longitude = parseFloat(this.longitude || 0);
      this.snackbar = false;
    },
    userFilter(item, queryText) {
      const textOne = item.text.toLowerCase();
      const textTwo = item.mobile;
      const searchText = queryText.toLowerCase();
      return textOne.search(searchText) > -1 || textTwo.search(searchText) > -1;
    },
    async getProvince() {
      try {
        this.data.postal_code = "";
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/province`).then((res) => {
          // console.log('province',res);
         if (res.data.code == 200 && res.data.result == "success") {
            this.province = res.data.data
          }
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getAmphoe(from) {
      try {
        this.data.postal_code = "";
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/province/amphoe/${this.data.province}`)
          .then((res) => {
            // console.log('amphoe',res);
            if (res.data.code == 200 && res.data.result == "success") {
              this.amphoe = res.data.data
                
              if (from == "template") {
                this.data.amphur = "";
                this.data.tambon = "";
              }
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getTambon() {
      try {
        this.data.postal_code = "";
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/province/amphoe/tambon/${this.data.province}/${this.data.amphur}`
          )
          .then((res) => {
            // console.log('tambon',res);
            if (res.data.code == 200 && res.data.result == "success") {
                this.tambon = res.data.data
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    getPostal(e) {
      var postal = this.tambon.find((ele) => {
        return ele.tambon === e;
      });

      if (postal !== undefined) {
        this.data.postal_code = postal.zipcode;
      } else {
        this.data.postal_code = "";
      }
    },
    check_address() {
      if (this.data.radius_serve_require) {
        if (this.data.radius_serve.length != 0) {
          return this.data.radius_serve.some((ele) => {
            return (
              ele.province === this.data.province &&
              ele.amphur === this.data.amphur &&
              ele.tambon === this.data.tambon
            );
          });
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkAlert() {
      const data = {
        title:
          "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;font-weight: 500;'>ท่านยืนยันข้อมูลการลงทะเบียนขอรับยาใช่หรือไม่</span>",
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText:
          "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
        cancelButtonColor: "#FFFFFF",
        showConfirmButton: true,
        confirmButtonText:
          "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        allowOutsideClick: false,
      };
      this.$refs.sweetDialog.open(data);
    },
    async saveForm() {
      if (!this.$refs.create_info.validate()) {
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      } else {
        this.save = this.data;

        this.save.mobile = this.splitMobile
        // this.save.mobile_other = this.splitOtherMobile
        // id_card_num
        if (this.data.id_card_type === "บัตรประจำตัวประชาชน") {
          var x = [];
          for (var i = 0; i < this.splitID.length; i++) {
            x.push(this.splitID[i]);
          }
          for (var j = 0; j <= 5; j++) {
            x[j] = "X";
          }
          var y = x.toString();
          this.save.cardnum = y.replaceAll(",", "");
        }

        // biz_id
        this.save.biz_id = sessionStorage.getItem('biz_id')

        // address
        if (this.data.moo && !this.data.road) {
          this.save.address =
            "บ้านเลขที่ " +
            this.data.houseNo +
            " หมู่ที่ " +
            this.data.moo +
            " ตำบล/แขวง" +
            this.data.tambon +
            " อำเภอ/เขต" +
            this.data.amphur +
            " จังหวัด" +
            this.data.province;
        } else if (!this.data.moo && this.data.road) {
          this.save.address =
            "บ้านเลขที่ " +
            this.data.houseNo +
            " ถนน/ซอย" +
            this.data.road +
            " ตำบล/แขวง" +
            this.data.tambon +
            " อำเภอ/เขต" +
            this.data.amphur +
            " จังหวัด" +
            this.data.province;
        } else if (!this.data.moo && !this.data.road) {
          this.save.address =
            "บ้านเลขที่ " +
            this.data.houseNo +
            " ตำบล/แขวง" +
            this.data.tambon +
            " อำเภอ/เขต" +
            this.data.amphur +
            " จังหวัด" +
            this.data.province;
        } else {
          this.save.address =
            "บ้านเลขที่ " +
            this.data.houseNo +
            " หมู่ที่ " +
            this.data.moo +
            " ถนน/ซอย" +
            this.data.road +
            " ตำบล/แขวง" +
            this.data.tambon +
            " อำเภอ/เขต" +
            this.data.amphur +
            " จังหวัด" +
            this.data.province;
        }

        if (this.data.postal_code !== "") {
          this.save.address =
            this.save.address + " รหัสไปรษณีย์ " + this.data.postal_code;
        }

        // birthday
        if (this.data.birth_date) {
          this.save.birth_date = this.data.birth_date || '';
        }

        // hospital_name
        this.save.hospital_name = sessionStorage.getItem('biz_name')

        //manual_type
        if (this.keyword) {
          this.save.manual_type = "new reserve";
        } else {
          this.save.manual_type = "new register";
        }

        // console.log("data : ", this.save);

        try {await this.axios
            .post(
              `${process.env.VUE_APP_BACKEND_URL}/v1/pharma/regis_manual`,
              this.save
            )
            .then((res) => {
              // console.log("res", res);
              String.prototype.insert = function(index, string) {
                  if (index > 0)
                  {
                    return this.substring(0, index) + string + this.substring(index, this.length);
                  }

                  return string + this;
                };
                var x = this.data.cardnum
                var result = x.insert(1, "-");
                var result2 = result.insert(6, "-");
                var result3 = result2.insert(12, "-");
                var result4 = result3.insert(15, "-");
                this.data.cardnum = result4

                var y = this.data.mobile
                if(y.length == 9) {
                  var y1 = y.insert(1, "-");
                  var y2 = y1.insert(6, "-");
                  this.data.mobile = y2
                } else if(y.length == 10) {
                  var y3 = y.insert(3, "-");
                  var y4 = y3.insert(7, "-");
                  this.data.mobile = y4
                }
              if(res.data.result == 'success' && res.data.message === "insert flash success") {
                this.$swal({
                  title:
                    "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ระยะทางในการจัดส่งยาอยู่นอกพื้นที่ที่กำหนด</span>",
                  html:
                    "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>จะได้รับยาผ่านช่องทางการจัดส่งยาโดย Flash Express</span>",
                  icon: "success",
                  showConfirmButton: false,
                  confirmButtonText: "ปิด",
                  confirmButtonColor: "#00A99D",
                });
                this.closeDialog();
                this.$emit("close");
              } else if(res.data.result == 'success' && res.data.message === "insert success") {
                this.$swal({
                  title:
                    "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
                  icon: "success",
                  showCloseButton: false,
                  showConfirmButton: false,
                  background: "white",
                });
                this.closeDialog();
                this.$emit("close");
              } else if (res.data.result === "fail") {
                this.$swal({
                  title:
                    "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>" +
                    res.data.message +
                    "</span>",
                  icon: "warning",
                  showCloseButton: false,
                  showConfirmButton: false,
                  background: "white",
                });
              } else {
                this.$swal({
                  title:
                    "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
                  icon: "error",
                  showCloseButton: false,
                  showConfirmButton: false,
                  background: "white",
                });
                this.closeDialog();
                this.$emit("close");
              }
            });
        } catch (err) {
          console.log(err);
        }
      }
    },
    clear() {
      this.data.cardnum = "";
    },
    displayDate() {
      var year1 = ""
      var year2 = ""
      if (!this.data.birth_date) return;
        year1 = moment(this.data.birth_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.birth_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect() {
      this.data.birth_date = null;
      this.day_menu = false;
      this.activePicker = null
    },
    changeLocation(e) {
      // console.log("9999999", e.latLng.lat());
      // console.log("9999999", e.latLng.lng());
      this.data.lat = e.latLng.lat();
      this.data.lng = e.latLng.lng();
      this.lat = e.latLng.lat();
      this.lng = e.latLng.lng();
    },
    checkGPS() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { coords: { latitude: lat, longitude: lng } = {} } = position;
          this.latitude = lat;
          this.longitude = lng;
          this.data.lat = lat;
          this.data.lng = lng;
          this.lat = lat;
          this.lng = lng;
        },
        (error) => {
          console.log(error);
          this.snackbar = true;
        }
      );
    },
    getGPS() {
      this.latitude = parseFloat(this.data.lat || 0);
      this.longitude = parseFloat(this.data.lng || 0);
      this.lat = parseFloat(this.data.lat || 0);
      this.lng = parseFloat(this.data.lng || 0);
    },
    async getDataUser(item) {
      try {
        const params = new URLSearchParams();
        // console.log("keyword", item);
        params.append("keyword", item);
        params.append("biz_id", sessionStorage.getItem('biz_id'));
        await this.axios
          .get(
            process.env.VUE_APP_BACKEND_URL + `/v1/pharma/get_user?${params}`
          )
          .then((res) => {
            // console.log("res", res);
            if (res.data.result == "success") {
              let getdata = res.data.data;
              this.users = [];
              getdata.forEach((e) => {
                this.users.push({
                  text: e.first_name_th + " " + e.last_name_th,
                  mobile: e.data_user.mobile,
                  value: e,
                });
              });
            }
          });
      } catch (error) {
        console.error();
      }
    },
    showAddress() {
      var text_address = "";
      // if (this.data.house_no !== "" && this.data.house_no !== undefined) {
      //   text_address += "บ้านเลขที่ " + this.data.house_no;
      // }
      // if (this.data.moo !== "" && this.data.moo !== undefined) {
      //   text_address += " หมู่ที่ " + this.data.moo;
      // }

      // if (this.data.road !== "" && this.data.road !== undefined) {
      //   text_address += " ถนน/ซอย " + this.data.road;
      // }

      if (this.data.tambon !== "" && this.data.tambon !== undefined) {
        text_address += " ตำบล " + this.data.tambon;
      }

      if (this.data.amphur !== "" && this.data.amphur !== undefined) {
        text_address += " อำเภอ " + this.data.amphur;
      }

      if (this.data.province !== "" && this.data.province !== undefined) {
        text_address += " จังหวัด " + this.data.province;
      }

      if (this.data.postal_code !== "" && this.data.postal_code !== undefined) {
        text_address += " รหัสไปรษณีย์ " + this.data.postal_code;
      }

      if (text_address == "") {
        this.getLocation(text_address)
        return "";
      } else {
        this.getLocation(text_address)
        return this.location_address = text_address;
      }
    },
    async getLocation(address) {
      // console.log('address', address);
      try {
        const params = new URLSearchParams();
        params.append("address", address);

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/pharma/get-location?${params}`).then((res) => {
          // console.log("res", res);
          if (res.data.result == "success" && res.data.code == 200) {
            var data = res.data.data
            this.latitude = data.lat;
            this.longitude = data.lng;
            this.data.lat = data.lat;
            this.data.lng = data.lng;
            this.lat = data.lat;
            this.lng = data.lng;
          } else {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ไม่สามารถค้นหาตำแหน่งที่อยู่ได้</span>",
              icon: "error",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
            });
          }
        });
      } catch (error) {
        console.error();
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ไม่สามารถค้นหาตำแหน่งที่อยู่ได้</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-input--selection-controls__input + .v-label {
  font-size: 18px !important;
  color: #333333 !important;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #313b41;
}

::v-deep .v-input--is-disabled > .v-input__control > .v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .v-toolbar__content {
  justify-content: center;
}

.text-red {
  color: red;
}

.container {
  max-width: 100%;
  max-height: 700px;
}

.v-dialog > .v-card > .v-card__text {
  padding: 0px;
}

.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .v-dialog {
  background-color: white !important;
}

::v-deep
  .v-text-field.v-text-field--solo.v-input--dense
  .v-input__append-outer {
  margin-top: 0px !important;
}

::v-deep .theme--light.v-select .v-select__selection--disabled {
  color: #313b41 !important;
}

.gmap-auto {
  width: 100%;
  line-height: 35px;
  border: 1px solid #e8e9e9;
  border-radius: 5px;
  font-size: 14px;
}

.gmap-auto:focus {
  outline: none !important;
}

::v-deep .v-select__selections {
  line-height: 1.8rem;
}

::v-deep .v-text-field.v-text-field--solo .v-input__control input {
  line-height: 1.8rem;
}

::v-deep .v-input input {
  line-height: 1.8rem;
}
</style>